import { useSelector } from 'react-redux';

export const usePermission = (category, pageName) => {
    const { userData } = useSelector(state => state.auth);

    // Default: all permissions granted for company
    if (userData?.login_type === 'company') {
        return { add: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true };
    }

    // For 'user' login type, check the permissions array
    if (userData?.login_type === 'user' && Array.isArray(userData?.permissions)) {
        const pagePermissions = userData.permissions.find(p =>
            p.category?.toLowerCase() === category?.toLowerCase() &&
            p.name?.toLowerCase() === pageName?.toLowerCase()
        ) || {};
        console.log('Page Category: ', category?.toLowerCase(), 'Page Name: ', pageName?.toLowerCase(), 'Permissions: ', userData?.permissions, 'pagePermissions: ', pagePermissions);
        return {
            add: !!pagePermissions.create,
            alter: !!pagePermissions.alter,
            view: !!pagePermissions.view,
            delete: !!pagePermissions.delete,
            print: !!pagePermissions.print,
            export: !!pagePermissions.export,
            email: !!pagePermissions.email,
            whatsapp: !!pagePermissions.whatsapp
        };
    }

    // Default to false if nothing matches or not logged in properly
    return { add: false, alter: false, view: false, delete: false, print: false, export: false, email: false, whatsapp: false };
};
